import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IItemAssigmentLogResponse {
  _id: string;
  userId: string;
  assignId: string;
  stepId?: string;
  assignName: string;
  userName: string;
  preSignedUrl: string;
  message: string;
  timeOut: number;
  createAt?: Date;
}

export interface AssigmentLogState {
  loading: boolean;
  data: IItemAssigmentLogResponse[];
  error: string;
  fetched: boolean;
  totalPage: number,
}

const initialState: AssigmentLogState = {
  loading: false,
  data: [],
  error: null,
  fetched: false,
  totalPage: 1,
};

export const assigmentSlice = createSlice({
  name: "assigmentLog",
  initialState,
  reducers: {
    getAssigmentLog: (state, action) => {
      state.loading = true;
      state.fetched = false;
    },
    getAssigmentLogSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data.assigmentsLogs;
      state.error = "";
      state.fetched = true;
      state.totalPage = action.payload.data.totalPage;
    },
    getAssigmentLogFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.data = [];
      state.error = "error";
      state.fetched = true;
      state.totalPage = 1;
    },
  },
});

export const {
  getAssigmentLog,
  getAssigmentLogSuccess,
  getAssigmentLogFailure,
} = assigmentSlice.actions;

export default assigmentSlice.reducer;
